import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Router from "./utilities/Router/Router";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./utilities/firebase/config";
import { getUserData } from "./utilities/const/functions";
import { AuthContext } from "./utilities/context/AuthContext";
import Loading from "./pages/Loading";
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserState, setLoading } = useContext(AuthContext);
  const getCurrentUser = async () => {
    if (location.pathname == "/") {
      navigate("/login", {
        replace: true,
      });
    }
    if (location.pathname == "/create-password") {
      return;
    }
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // console.log({ userAuth: user });
        setLoading(true);
        // console.log(user.uid);
        const res = await getUserData(user.uid);
        // console.log({ res });
        if (!res.error) {
          // console.log({ ...res.userData, uid: user.uid });
          if (res.userData.role !== "admin") {
            await signOut(auth);
            window.alert("Not Allowed");
            // navigate("/login");
            return;
          }
          setUserState({ ...res.userData, uid: user.uid });
          if (location.pathname == "/") {
            navigate("/home", {
              replace: true,
            });
          }
          // navigate("/home");
        } else {
          await signOut(auth);
          alert(res.message);
        }
        setLoading(false);
      } else {
        setLoading(false);
        console.log("no user logged in");
        navigate("/login", {
          replace: true,
        });
      }
    });
  };
  useEffect(() => {
    // navigate("/login");
    getCurrentUser();
  }, []);

  return (
    <>
      <Router />
      <Loading />
    </>
  );
}

export default App;
